/* ==========================================================================
   ATN Homepage V1.0 — Section 10: Footer (block-based)
   Spec reference: 10_Section.docx §19 (mobile accordion), §31 (analytics)

   - Mobile accordion: menu columns collapse; tapping the title toggles them.
     Only active at mobile width when the section's accordion option is on.
   - Analytics: fires homepage_footer_link_click on footer link clicks.
   ========================================================================== */

(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';

  function deviceType() {
    var w = window.innerWidth;
    if (w <= 749) return 'mobile';
    if (w <= 1000) return 'tablet';
    return 'desktop';
  }

  function sectionIdFrom(el) {
    var wrapper = el.closest('[id^="shopify-section-"]');
    return wrapper ? wrapper.id.replace('shopify-section-', '') : '';
  }

  function send(root, eventName, params) {
    if (root.dataset.analytics !== 'true' || !eventName) return;

    var payload = Object.assign(
      {
        device_type: deviceType(),
        section_id: sectionIdFrom(root),
        current_page: window.location.pathname
      },
      params || {}
    );

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    }
  }

  /* ---- Analytics ------------------------------------------------------- */

  function bindAnalytics(root) {
    if (root.dataset.analytics !== 'true') return;

    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-atn-ft-link]');
      if (!link) return;

      send(root, 'homepage_footer_link_click', {
        link_text: link.dataset.atnFtLink || '',
        destination_url: link.getAttribute('href') || ''
      });
    });
  }

  /* ---- Mobile accordion ------------------------------------------------ */

  function bindAccordion(root) {
    if (root.dataset.mobileAccordion !== 'true') return;

    var mql = window.matchMedia(MOBILE_QUERY);
    var cols = Array.prototype.slice.call(
      root.querySelectorAll('[data-atn-ft-accordion]')
    );

    cols.forEach(function (col) {
      var toggle = col.querySelector('[data-atn-ft-accordion-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        if (!mql.matches) return; // desktop: do nothing, links always shown
        var open = col.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    function syncState() {
      cols.forEach(function (col) {
        var toggle = col.querySelector('[data-atn-ft-accordion-toggle]');
        if (mql.matches) {
          // Collapsed by default on mobile
          col.classList.remove('is-open');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        } else {
          // Desktop: ensure open state / reset aria
          col.classList.remove('is-open');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    if (mql.addEventListener) {
      mql.addEventListener('change', syncState);
    } else if (mql.addListener) {
      mql.addListener(syncState);
    }
    syncState();
  }

  function bind(root) {
    if (root.dataset.atnFtBound === 'true') return;
    root.dataset.atnFtBound = 'true';
    bindAnalytics(root);
    bindAccordion(root);
  }

  function init(scope) {
    (scope || document)
      .querySelectorAll('[data-atn-ft-root]')
      .forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();